import { LendingOutboundPackageVolumeWeekdayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../../../analytics/insights/heatmap-cell-summary/use-insight-heatmap-cell-click';
import { StatisticsCard } from '../../shared';
import { useLast6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart } from './use-last-6-months-lending-outbound-package-volume-weekday-heatmap-chart';

export interface Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChartProps {
    accountId: string;
}

export const Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart = (props: Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChartProps) => {
    const { data, isLoading, rangeStart, weekCount } = useLast6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart(props);
    const title = (
        <FormattedMessage
            id='platform.statistics.lending.last-6-months-lending-outbound-package-volume-weekday-heatmap-chart.title'
            description='Title of the lending heatmap showing pick-up package volume by weekday over the last six months'
            defaultMessage='Pick-up heatmap'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId: props.accountId,
        chartKey: LendingOutboundPackageVolumeWeekdayHeatmapChart.definition.key,
        title
    });

    return (
        <StatisticsCard
            chartKey={LendingOutboundPackageVolumeWeekdayHeatmapChart.definition.key}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.statistics.lending.last-6-months-lending-outbound-package-volume-weekday-heatmap-chart.subtitle'
                    description='Subtitle on the lending pick-up heatmap indicating the chart covers the last six months'
                    defaultMessage='last 6 months'
                />
            }
            isLoading={isLoading}
            hasData={hasChartSeries(data)}>
            {hasChartSeries(data) && data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <LendingOutboundPackageVolumeWeekdayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        weekCount={weekCount}
                        minHeight={220}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
